import { exeRequest } from '../utils/APIUtils';

const toQS = (obj = {}) => {
    const q = Object.entries(obj)
        .filter(([, v]) => v !== undefined && v !== null && v !== '')
        .map(([k, v]) => `${k}=${encodeURIComponent(v)}`)
        .join('&');
    return q ? `?${q}` : '';
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    // historiquePoints: async () => exeRequest(`/admin/historique-points`, "GET"),
     historiquePoints: async (params) => exeRequest(`/admin/historique-points${toQS(params)}`, "GET"),
    historiquePointsStatsToday: async (params) => exeRequest(`/admin/historique-points/stats-today${toQS(params)}`, "GET"),
    getFluxWallet: async (params) => exeRequest(`/admin/wallet/flux${toQS(params)}`, "GET"),
    getSoldeWallet: async () => exeRequest(`/admin/wallet`, "GET"),
    getEvolutionWallet: async (params) => exeRequest(`/admin/wallet/evolution${toQS(params)}`, "GET"),
};
